<template>
  <div class="active-click" @click="turnOff">
    <div class="book-index effect8">
      <div class="book-index-text"><span class="">Spis treści</span></div>
      <div class="book-index-container">
        <div class="book-index-chapter">
          <tr-book-index-main-link>
            <div slot="chapterIndex"></div>
            <div slot="text"></div>
          </tr-book-index-main-link>
          <tr-book-index-link page-id="2">
            <div slot="chapterIndex">1.</div>
            <div slot="text">W pracowni komputerowej</div>
            <div slot="pageIndex">2</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="4">
            <div slot="chapterIndex">2.</div>
            <div slot="text">Poznajemy komputer</div>
            <div slot="pageIndex">4</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="6">
            <div slot="chapterIndex">3.</div>
            <div slot="text">Program Paint</div>
            <div slot="pageIndex">6</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="8">
            <div slot="chapterIndex">4.</div>
            <div slot="text">Rysujemy w edytorze grafiki Paint</div>
            <div slot="pageIndex">8</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="10">
            <div slot="chapterIndex">5.</div>
            <div slot="text">Uruchamiamy program Paint</div>
            <div slot="pageIndex">10</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="12">
            <div slot="chapterIndex">6.</div>
            <div slot="text">Porządkujemy foldery</div>
            <div slot="pageIndex">12</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="14">
            <div slot="chapterIndex">7.</div>
            <div slot="text">Kodujemy</div>
            <div slot="pageIndex">14</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="16">
            <div slot="chapterIndex">8.</div>
            <div slot="text">Kopiujemy obrazki</div>
            <div slot="pageIndex">16</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="18">
            <div slot="chapterIndex">9.</div>
            <div slot="text">Zapisujemy efekty pracy na komputerze</div>
            <div slot="pageIndex">18</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="20">
            <div slot="chapterIndex">10.</div>
            <div slot="text">Ćwiczymy spostrzegawczość</div>
            <div slot="pageIndex">20</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="22">
            <div slot="chapterIndex">11.</div>
            <div slot="text">Zabawa w kodowanie</div>
            <div slot="pageIndex">22</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="24">
            <div slot="chapterIndex">12.</div>
            <div slot="text">Malujemy pędzlem w programie Paint</div>
            <div slot="pageIndex">24</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="26">
            <div slot="chapterIndex">13.</div>
            <div slot="text">Malujemy aerografem w programie Paint</div>
            <div slot="pageIndex">26</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="28">
            <div slot="chapterIndex">14.</div>
            <div slot="text">Rysujemy bałwanka</div>
            <div slot="pageIndex">28</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="30">
            <div slot="chapterIndex">15.</div>
            <div slot="text">Rysujemy figury w programie Paint</div>
            <div slot="pageIndex">30</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="32">
            <div slot="chapterIndex">16.</div>
            <div slot="text">Grafika komputerowa</div>
            <div slot="pageIndex">32</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="34">
            <div slot="chapterIndex">17.</div>
            <div slot="text">Pierwsze kroki w programie Paint 3D</div>
            <div slot="pageIndex">34</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="36">
            <div slot="chapterIndex">18.</div>
            <div slot="text">Czyścimy rysunki</div>
            <div slot="pageIndex">36</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="38">
            <div slot="chapterIndex">19.</div>
            <div slot="text">Poznajemy klawiaturę komputerową</div>
            <div slot="pageIndex">38</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="40">
            <div slot="chapterIndex">20.</div>
            <div slot="text">Liczymy w programie Kalkulator</div>
            <div slot="pageIndex">40</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="42">
            <div slot="chapterIndex">21.</div>
            <div slot="text">Poznajemy edytor tekstu Word</div>
            <div slot="pageIndex">42</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="44">
            <div slot="chapterIndex">22.</div>
            <div slot="text">Piszemy wielkimi literami</div>
            <div slot="pageIndex">44</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="46">
            <div slot="chapterIndex">23.</div>
            <div slot="text">Piszemy ukryte litery</div>
            <div slot="pageIndex">46</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="48">
            <div slot="chapterIndex">24.</div>
            <div slot="text">Poznajemy Scratch</div>
            <div slot="pageIndex">48</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="50">
            <div slot="chapterIndex">25.</div>
            <div slot="text">Roboty wokół nas</div>
            <div slot="pageIndex">50</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="52">
            <div slot="chapterIndex">26.</div>
            <div slot="text">Powtarzamy wiadomości</div>
            <div slot="pageIndex">52</div>
          </tr-book-index-link>
          <tr-book-index-link page-id="54">
            <div slot="chapterIndex">27.</div>
            <div slot="text">Bawimy się i uczymy przy komputerze</div>
            <div slot="pageIndex">54</div>
          </tr-book-index-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrBookIndexMainLink from './TrBookIndexMainLink/TrBookIndexMainLink';
import TrBookIndexLink from './TrBookIndexLink/TrBookIndexLink';
export default {
  name: 'tr-book-index',
  components: {
    TrBookIndexLink,
    TrBookIndexMainLink,
  },
  data: function () {
    return {};
  },
  methods: {
    turnOff() {
      this.$store.commit('SHOW_BOOK_INDEX', !this.showBookIndex);
      this.$store.commit('BOOK_INDEX_ACTIVE', !this.bookIndexActive);
    },
  },
  computed: {
    showBookIndex() {
      return this.$store.getters.showBookIndex;
    },
    bookIndexActive() {
      return this.$store.getters.bookIndexActive;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/bookIndexVariable';
.active-click {
  position: absolute;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .book-index {
    position: absolute;
    z-index: 100000;
    top: $bookIndexTop;
    left: $bookIndexLeft;
    width: $bookIndexWidth;
    height: $bookIndexHeight;
    background-color: $bookIndexBackgroundColor;
    // border: solid 1px black;
    border-radius: 10px 10px 0 0;
    // padding-bottom: 12px;
    font-size: $bookIndexFontSize;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-family: $bookIndexFontFamily;
    .book-index-text {
      display: flex;
      padding: $bookIndexTextPadding;
      span {
        font-size: $bookIndexTextFontSize;
        font-weight: bold;
      }
    }
    .book-index-container {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      overflow-y: scroll;
      margin-top: 28px;
      padding-bottom: 28px;
      .book-index-chapter {
        display: flex;
        width: 96%;
        flex-direction: column;
        padding: $bookIndexChapterPadding;
      }
    }
  }
  .effect8 {
    position: relative;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
  }
  .effect8:after,
  .effect8:before {
    content: '';
    position: absolute;
    z-index: -1; // box-shadow: 0 0 20px rgba(0,0,0,0.8);
    box-shadow: 3px 6px 20px rgba(0, 0, 0, 0.8);
    // top: 10px;
    // bottom: 10px;
    left: 0;
    right: 0;
    // border-radius: 100px / 10px;
  }
  .effect8:after {
    // right: 10px;
    left: auto;
    // transform: skew(8deg) rotate(3deg);
  }
}
</style>
